import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MsgKeyModule } from '../../translate/msg-key.module';
import { DialogService } from './dialog.service';

@NgModule({
	imports: [
		CommonModule,
		MsgKeyModule,
	],
})
export class DialogModule {
	static forRoot(): ModuleWithProviders<any> {
		return {
			ngModule: DialogModule,
			providers: [DialogService],
		};
	}
}
